























































































































































































import {
  getBookSubjectListApi,
  getBookCategoryListApi,
  bookSelectListData,
  bookSelectListApi,
} from "@/api/book";
import { Prop, Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originData!: {}[];
  @Prop() originType!: number;
  dialogVisible: boolean = false;
  form = {
    type: 1,
  };
  rules = {
    type: [{ required: true, message: "请选择", trigger: "change" }],
  };
  searchInfo = {
    book_title: "",
    subject_id: "",
    category_id: "",
  };
  subjectList = [];
  categoryList = [];
  allBook = [];
  selectedObject: any = {};
  selectedAllObject: any = {};
  selectedList: any[] = [];
  selectedAllList: any[] = [];
  tableData: any[] = [];
  aLLTableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  allPage: number = 1;
  allPageSize: number = 10;
  allPageSizeArray: number[] = [5, 10, 30, 50, 100];
  allTotal: number = 0;
  showDialog() {
    this.form.type = this.originType;
    const obj: any = {};
    this.originData.map((item: any) => {
      obj[item.book_id] = item;
    });
    if (this.originType === 2) {
      this.selectedList = [...this.originData];
      this.selectedObject = obj;
    }
    this.dialogVisible = true;
    this.getAllList({
      page: 1,
      page_size: this.pageSize,
    });
    this.handleSearch();
    getBookSubjectListApi().then((res: any) => {
      this.subjectList = res.data.list;
    });
    getBookCategoryListApi().then((res: any) => {
      this.categoryList = res.data.list;
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getAllList(v: { page: number; page_size: number }) {
    bookSelectListApi({
      page: v.page,
      page_size: v.page_size,
    }).then((res: any) => {
      res.data.list.map((item: any) => {
        item.checked = true;
      });
      this.aLLTableData = res.data.list;
      this.allTotal = res.data.total;
      this.allPage = res.data.page;
      this.allPageSize = res.data.page_size;
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: bookSelectListData = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.book_title) {
      option.book_title = this.searchInfo.book_title;
    }
    if (this.searchInfo.subject_id) {
      option.subject_id = Number(this.searchInfo.subject_id);
    }
    if (this.searchInfo.category_id) {
      option.category_id = Number(this.searchInfo.category_id);
    }
    bookSelectListApi(option).then((res: any) => {
      res.data.list.map((item: any) => {
        if (this.selectedObject[item.book_id]) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.page = res.data.page;
    });
  }
  handleBookSelect(row: any) {
    const copy = { ...this.selectedObject };
    if (copy[row.book_id]) {
      delete copy[row.book_id];
    } else {
      copy[row.book_id] = row;
    }
    this.selectedObject = copy;
    const items = [];
    for (const key in copy) {
      items.push(copy[key]);
    }
    this.selectedList = items;
    const index = this.tableData.findIndex((item: any) => {
      return item.book_id === row.book_id;
    });
    if (index >= 0) {
      this.tableData[index].checked = !!copy[row.book_id];
    }
  }
  handleCancel() {
    this.dialogVisible = false;
  }
  handleConfirm() {
    if (this.form.type === 1) {
      // 处理成空对象数组[{},{}...]传出去给 已授权xxx本 ,的 数组.length 使用
      const arr = [];
      for (let i = 0; i < this.allTotal; i++) {
        arr.push({});
      }
      this.$emit("change", {
        type: 1,
        list: arr,
      });
    }
    if (this.form.type === 2) {
      this.$emit("change", {
        type: 2,
        list: this.selectedList,
      });
    }
    this.dialogVisible = false;
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  handleAllPagerChange(e: number) {
    this.getAllList({
      page: e,
      page_size: this.allPageSize,
    });
  }
  handleAllPagerSizeChange(e: number) {
    this.allPageSize = e;
    this.getAllList({
      page: 1,
      page_size: e,
    });
  }
}
